<codemirror-tag>
    <slot/>
    <script>
        export default {
            cm: null,
            emitcm: null,
            onMounted(props, state) {
                let width    = (typeof props.width !== 'undefined') ?  props.width : 'auto'
                let height   = (typeof props.height !== 'undefined') ?  props.height : 'auto'
                let readonly = (typeof props.readonly !== 'undefined') ?  true : false
                this.emitcm  = (typeof props.onupdate !== 'undefined') ?  props.onupdate : null
                console.log(readonly)

                let body = this.root.innerHTML
                this.root.innerHTML = ''
                this.cm = CodeMirror(
                    this.root,
                    {
                        mode: 'simplemode',
                        readOnly: readonly,
                        autofocus: true,
                        label: 'label',
                        styleActiveLine: true,
                        lineNumbers: true,
                        lineWrapping: true,
                        scrollbarStyle: 'simple',
                        gutters: ['CodeMirror-linenumbers', 'leafpoints'],
                        tabSize: 4,
                        value: body
                    }
                )
                this.cm.setSize(width, height);
            },
            onUpdated(props, state) {
                if (null !== this.emitcm) {
                    this.emitcm(this.cm)
                }
            }
        }
    </script>
    <style>
        .CodeMirror {border-top: 1px solid black; border-bottom: 1px solid black;}
        .CodeMirror-selected  { background-color: blue !important; }
        .CodeMirror-selectedtext { color: white; }
        .styled-background { background-color: #ff7; }
    </style>
</codemirror-tag>
